import { IconServers } from '@smartbear/swagger-portal-component-library'

import { ApiSubNavItem } from '../ApiSubNavItem'
import { AsyncApiServer } from '~/portal/types/content'

export const ApiSubNavServer = ({
  parentPath,
  server,
  active = false,
  isSelected,
  setSelectedServer,
  onClick,
}: {
  parentPath: string,
  server: AsyncApiServer,
  active?: boolean,
  isSelected: boolean,
  setSelectedServer: (selectedServer: string | null) => void,
  onClick?: (e) => void,
}) => {
  const serverIdentifier = server.serverId
  const serverHash = `#/default/server-${encodeURIComponent(serverIdentifier)}`

  return (
    <ApiSubNavItem
      parentPath={parentPath}
      identifier={serverIdentifier}
      hash={serverHash}
      icon={<IconServers width={12} height={12} />}
      active={active}
      isSelected={isSelected}
      setSelectedItem={setSelectedServer}
      onClick={onClick}
    />
  )
}